module.exports = {
      id: "icon-audio-play-store-usage",
      viewBox: "0 0 122 41",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#icon-audio-play-store",
      toString: function () {
        return this.url;
      }
    }